<template>
    <icon-base width="26" height="26" viewBox="0 0 26 26">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M9.16536 2.5H15.832L16.6654 5L15.2582 4.29643C15.0977 4.21619 14.907 4.22773 14.7506 4.31573C14.3247 4.55545 13.4117 5 12.4987 5C11.5857 5 10.6727 4.55545 10.2468 4.31573C10.0904 4.22773 9.89966 4.21619 9.73917 4.29643L8.33203 5L9.16536 2.5Z"
              fill="#9E9E9E"></path>
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M8.16 6.62289C7.81009 3.9986 9.85167 1.66675 12.4992 1.66675V1.66675C15.1467 1.66675 17.1883 3.9986 16.8384 6.62289L16.2731 10.8627C16.0209 12.7541 14.4074 14.1667 12.4992 14.1667V14.1667C10.591 14.1667 8.9775 12.7541 8.7253 10.8627L8.16 6.62289Z"
              stroke="#9E9E9E" stroke-width="2" stroke-linecap="round"></path>
        <path d="M7.49935 15.8335L3.8172 16.754C3.0217 16.9529 2.42819 17.6172 2.31982 18.43L2.11888 19.937C1.87909 21.7355 3.2782 23.3335 5.09256 23.3335H16.666"
              stroke="#9E9E9E" stroke-width="2" stroke-linecap="round"></path>
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M19.9987 24.1668C22.2999 24.1668 24.1654 22.3013 24.1654 20.0002C24.1654 17.699 22.2999 15.8335 19.9987 15.8335C17.6975 15.8335 15.832 17.699 15.832 20.0002C15.832 22.3013 17.6975 24.1668 19.9987 24.1668Z"
              stroke="#D0320F" stroke-width="2" stroke-linecap="round"></path>
        <path d="M17.082 17.0835L22.9154 22.9168" stroke="#D0320F" stroke-width="2" stroke-linecap="round"></path>
    </icon-base>
</template>

<script>
    import IconBase from "../../IconBase";
    export default {
        name: 'icon-canceled-by-customer',
        components: {IconBase}
    }
</script>